import React from "react";

export const JourneySummaryModern = () => {
  const stats = [
    { number: "340k+", text: "Active Users" },
    { number: "825", text: "Running Days" },
    { number: "125", text: "Awards Won" },
    { number: "175", text: "Global Presence" },
  ];

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <img
        src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
        alt="Office Background"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* primary Overlay (Stronger opacity for text readability) */}
      <div className="absolute inset-0 bg-primary/90 mix-blend-multiply z-10"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent z-10"></div>

      <div className="relative container mx-auto px-6 z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left Side: Text Content */}
          <div className="lg:w-1/2 text-white">
            <span className="inline-block py-1 px-3 rounded-full bg-white/10 text-xs font-bold tracking-widest uppercase mb-4 backdrop-blur-md border border-white/20">
              Our Track Record
            </span>
            <h2 className="text-4xl lg:text-5xl font-heading font-bold mb-6 leading-tight">
              A Summary of <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-primary-200">
                Our Journey
              </span>
            </h2>
            <p className="text-lg text-primary-100 leading-relaxed font-light max-w-lg">
              We have over the years gathered loads of experiences that have
              consequently boosted our portfolio in the world of financial
              services.
            </p>
          </div>

          {/* Right Side: Stats Grid in Glass Cards */}
          <div className="lg:w-1/2 w-full">
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300 text-center lg:text-left"
                >
                  <h3 className="text-3xl lg:text-4xl font-bold text-white mb-1">
                    {stat.number}
                  </h3>
                  <p className="text-sm font-medium text-primary-200 uppercase tracking-wide">
                    {stat.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
